import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=13caadb4"
import script from "./OpenQuestion.vue?vue&type=script&lang=ts"
export * from "./OpenQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports